module.exports = __webpack_public_path__ + "static/UnboundWorldsApart1-1ace73143aef7c9976a7643f99bf41ae.webp";